export const certifications = [
  {
    id: 'aws-cloud-practitioner',
    title: 'AWS Certified Cloud Practitioner',
    issuer: 'Amazon Web Services',
    status: 'earned',
    year: '2024',
    credentialUrl: 'https://www.credly.com/badges/02322ad6-d10a-48bc-8e88-d5c6503889f6/public_url',
    badgeId: '02322ad6-d10a-48bc-8e88-d5c6503889f6',
  },
  {
    id: 'google-cybersecurity',
    title: 'Google Cybersecurity Certificate',
    issuer: 'Google (Coursera)',
    status: 'earned',
    year: '2024',
    credentialUrl: 'https://coursera.org/share/30ae386f71968fea7b85ee7d81983e1a',
  },
  {
    id: 'aws-solutions-architect',
    title: 'AWS Certified Solutions Architect',
    issuer: 'Amazon Web Services',
    status: 'planned',
  },
]
